import { Grid } from 'ht-styleguide';
import SubHeaderContent from './SubHeaderContent';
import ZipEmailBlock from './ZipEmailBlock';
import styles from '../locationPage.module.scss';
import { SkuBullet } from 'types/sku.types';

type SubHeaderProps = {
  serviceName: string;
  cityName: string;
  serviceBullets: SkuBullet[];
  ratingAttributes: {
    rating: number;
    ratingCount: number;
  };
  skuId: number;
  onRatingClick: BaseAnyFunction | null;
  onGetPriceClick: BaseAnyFunction;
};

const SubHeader = (props: SubHeaderProps) => (
  <Grid.Fluid>
    <Grid.Row classes={styles.subHeaderWrapper}>
      <Grid.Column mdOffset={1} md={6} lgOffset={1} lg={5} classes={styles.subHeaderCity}>
        <SubHeaderContent {...props} />
      </Grid.Column>
      <Grid.Column sm={4} md={5} lgOffset={1} lg={4} classes="marginAuto">
        <ZipEmailBlock {...props} />
      </Grid.Column>
    </Grid.Row>
  </Grid.Fluid>
);

export default SubHeader;
